export function initAdminHeaderNav(root: ParentNode = document): void {
  root.querySelectorAll<HTMLButtonElement>("[data-admin-header-back]").forEach((button) => {
    if (button.dataset.adminHeaderNavBound === "1") return;
    button.dataset.adminHeaderNavBound = "1";
    button.addEventListener("click", () => {
      window.history.back();
    });
  });

  root.querySelectorAll<HTMLButtonElement>("[data-admin-header-forward]").forEach((button) => {
    if (button.dataset.adminHeaderNavBound === "1") return;
    button.dataset.adminHeaderNavBound = "1";
    button.addEventListener("click", () => {
      window.history.forward();
    });
  });
}
